import { PageProps } from "gatsby";
import { GlobalContext } from "components/stores/global-context";
import { useContext } from "react";
import SiteConfig from "components/stores/site-configuration-store";
import { Html, LinkTags, MetaTags, Title } from "@parksandresorts/core";
import { RideMediaQrCodePageContext, RideMediaQrCodePageData } from "../../templates/digital-ride-media-qr-code-page";

type Props = PageProps<RideMediaQrCodePageData, RideMediaQrCodePageContext>;

export const Head = (props: Props) => {
  const context = useContext(GlobalContext);
  const node_locale = props.data.contentfulSiteConfiguration.node_locale;
  const qrCode: string | undefined = props.params["*"];
  const pageTitleBase = SiteConfig.getLabel("RIDE_MEDIA_QR_CODE_PAGE_TITLE", "Attraktionsbilder - QR Kod");
  const pageTitle = qrCode ? `${pageTitleBase} ${qrCode}` : pageTitleBase;
  const pageDescription = SiteConfig.getLabel("RIDE_MEDIA_QR_CODE_PAGE_DESCRIPTION", "Dina attraktionsbilder!");

  return (
    <>
      <Html isViewportScrollable={context.isViewportScrollable} lang={node_locale} />
      <Title title={pageTitle} />
      <MetaTags description={pageDescription} robots="noindex,follow" />
      <LinkTags />
    </>
  );
};
